import axios from 'axios';
import React, { useState } from 'react';
import { useForm } from "react-hook-form"
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import "../App.css"
import FadeLoader from "react-spinners/FadeLoader";

function PasswordChangeAdmin({ IP, UserObj }) {

    const { register, handleSubmit, formState: { errors } } = useForm();
    const [changing, setChanging] = useState(false)

    const changePassword = async (formData) => {
        formData = { ...formData, username: UserObj.username }
        setChanging(true)
        await axios.post(`http://${IP}/change-fs-admin-password`, formData)
            .then((response) => {
                if (response.data.msg === "Password changed successfully") {
                    notifySuccess(response.data.msg)
                    setChanging(false)
                }
                else if (response.data.msg === "Invalid Details") {
                    notifyError(response.data.msg)
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

    const notifySuccess = (msg) =>
        toast.success(msg, {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });

    const notifyError = (msg) =>
        toast.error(msg, {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });

    return (
        <div>
            {
                changing === true ?
                    <div className='form-loading'>
                        <FadeLoader
                            className='mx-auto'
                            color="#012951"
                            loading={changing}
                        />
                        <h5 className='text-center mt-2 p-3'>Changing password...</h5>
                    </div>
                    :
                    <form className='form mt-5 m-auto mb-2' onSubmit={handleSubmit(changePassword)}>

                        <h4 className='text-center'>Change Password</h4>

                        <div className='form-group'>
                            <label htmlFor="password"><small>Current Password</small></label>
                            <input type="password" id="password" className="form-control" placeholder="Password" {...register("currentpassword", { required: true })} />
                            {errors.password && <small className='text-danger'>Current password is required</small>}
                        </div>

                        <div className='form-group'>
                            <label htmlFor="password1"><small>New Password</small></label>
                            <input type="password" id="password1" className="form-control" placeholder="Password" {...register("newpassword", { required: true })} />
                            {errors.password && <small className='text-danger'>New password is required</small>}
                        </div>

                        <div className='form-group'>
                            <button className='btn btn-success w-100 rounded-button'>Change Password</button>
                        </div>
                    </form>
            }


            <ToastContainer
                position="top-center"
                autoClose={3000}
                hideProgressBar={true}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </div>
    );
}

export default PasswordChangeAdmin;